<template>
  <div>
    <el-dialog
      title="修改密码"
      :visible.sync="dialog"
      width="500px"
      :close-on-click-modal="false"
      top="50px"
      append-to-body>
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="110px">
        <el-form-item
          label="旧密码："
          prop="oldPwd"
          :rules="formRules.password">
          <el-input
            v-model="form.oldPwd"
            auto-complete="new-password"
            autocomplete="off"
            placeholder="8-16位数字大小写字母组合"></el-input>
        </el-form-item>
        <el-form-item
          label="新密码："
          prop="newPwd"
          :rules="formRules.newPwd(form)">
          <el-input
            style="width: calc(100% - 90px);"
            placeholder="8-16位数字大小写字母组合"
            auto-complete="new-password"
            autocomplete="off"
            type="text"
            show-password
            @keyup.enter.native="handleSubmit"
            v-model="form.newPwd"></el-input>
          <el-button
            class="marginL-10"
            type="primary"
            @click="handlerestPw">随机密码
          </el-button>
        </el-form-item>
        <el-form-item
          label="确认新密码："
          prop="new_pwd"
          :rules="formRules.confirmPassword(form)">
          <el-input
            placeholder="8-16位数字大小写字母组合"
            auto-complete="new-password"
            autocomplete="off"
            type="text"
            show-password
            @keyup.enter.native="handleSubmit"
            v-model="form.new_pwd"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" :disabled="booLock" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRandomPw } from '@/utils'

export default {
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialog: !!this.value,
      form: {
        oldPwd: '', // 老的密码
        newPwd: '', // 新密码
        new_pwd: '' // 确认新密码
      },
      booLock: false
    }
  },
  methods: {
    handlerestPw() {
      this.$set(this.form, 'newPwd', getRandomPw())
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const postData = {
            ...this.form
          }

          delete postData.new_pwd

          this.booLock = true
          const { code } = await this.$fetch('/api/user/user/resetCurrentUserPwd', postData)
          if (code === 20000) {
            await this.$store.dispatch('user/logout')
            this.$router.push(`/login`)
          }
          this.booLock = false
        } else {
          return false
        }
      })

    }
  },
  watch: {
    dialog(val) {
      if (!val) this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
